import Service, { service } from '@ember/service';

import * as Sentry from '@sentry/ember';

import { apiBaseURL, apiNamespace } from 'register-partners-js/constants/hosts';
import { ErrorInfo } from 'register-partners-js/utils/error-info';

export default class MarketingConsentService extends Service {
  // oxlint-disable-next-line typescript/no-explicit-any
  @service declare networkManager: any;

  async submitMarketingConsent(email: string, consent: boolean): Promise<void> {
    const url = `${apiBaseURL}/${apiNamespace}/marketing_consent/lead_consents`;
    const payload = { email, consent };

    const requestOptions = {
      method: 'POST',
      body: JSON.stringify(payload),
      headers: {
        Accept: 'application/json',
      },
    };

    try {
      // oxlint-disable-next-line typescript/no-unsafe-member-access
      await this.networkManager.request(url, requestOptions);
    } catch (error) {
      const errorInfo = ErrorInfo.for(error);
      if (errorInfo.shouldSendToSentry) {
        Sentry.captureException(error, {
          tags: { component: 'marketing-consent' },
          extra: { email, consent, url },
        });
      }
    }
  }
}

declare module '@ember/service' {
  interface Registry {
    'marketing-consent': MarketingConsentService;
    marketingConsent: MarketingConsentService;
  }
}
